import { coinAPI } from "../api/api";
import {
  ADD_CURRENCY,
  REMOVE_CURRENCY,
  SET_TOP_CURRENCIES,
  UPDATE_CURRENCY,
} from "./types";

export const addCurrency = (currency, amount) => ({
  type: ADD_CURRENCY,
  payload: { currency, amount },
});

export const removeCurrency = (currency) => ({
  type: REMOVE_CURRENCY,
  payload: { currency },
});

const updateCurrency = (currency) => ({
  type: UPDATE_CURRENCY,
  payload: { currency },
});

const setTopCurrencies = (currencies) => ({
  type: SET_TOP_CURRENCIES,
  payload: { currencies },
});

export const getCurrency = (id) => {
  return async (dispatch) => {
    const response = await coinAPI.getCurrency(id);
    dispatch(updateCurrency(response.data.data));
  };
};

export const getTopCurrencies = () => {
  return async (dispatch) => {
    const response = await coinAPI.getTopCurrencies();
    dispatch(setTopCurrencies(response.data.data));
  };
};

export const getPortfolioData = (portfolio) => {
  return (dispatch) => {
    for (let i = 0; i < portfolio.length; i++) {
      dispatch(getCurrency(portfolio[i].id));
    }
  };
};
